import React from 'react';
import PropTypes from 'prop-types';

export const Time = ({ width, height, ...props }) => (
  <svg
    data-icon='time'
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 32 32'
    {...props}
  >
    <path
      fill='currentColor'
      d='M12 4V1.333h8V4h-8Zm2.667 14.666h2.666v-8h-2.666v8ZM16 29.333c-1.644 0-3.194-.317-4.65-.95A12.256 12.256 0 0 1 7.533 25.8a12.257 12.257 0 0 1-2.583-3.817 11.527 11.527 0 0 1-.95-4.65c0-1.644.317-3.194.95-4.65a12.258 12.258 0 0 1 2.583-3.817 12.257 12.257 0 0 1 3.817-2.583 11.528 11.528 0 0 1 4.65-.95c1.378 0 2.7.222 3.967.667a12.964 12.964 0 0 1 3.566 1.933L25.4 6.066l1.867 1.867L25.4 9.8a12.964 12.964 0 0 1 1.933 3.566c.445 1.267.667 2.59.667 3.967 0 1.645-.317 3.195-.95 4.65a12.256 12.256 0 0 1-2.583 3.817 12.256 12.256 0 0 1-3.817 2.583c-1.456.633-3.006.95-4.65.95Zm0-2.667c2.578 0 4.778-.91 6.6-2.733 1.822-1.822 2.733-4.022 2.733-6.6 0-2.578-.91-4.778-2.733-6.6C20.778 8.911 18.578 8 16 8c-2.578 0-4.778.91-6.6 2.733-1.822 1.822-2.733 4.022-2.733 6.6 0 2.578.91 4.778 2.733 6.6 1.822 1.822 4.022 2.733 6.6 2.733Z'
    />
  </svg>
);

Time.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Time.defaultProps = {
  width: 32,
  height: 32,
};
